import React, { memo, useContext } from 'react';
import PropTypes from 'prop-types';
import './css/HomePage1Events1.css';
import { useHistory } from 'react-router-dom';
import { isValidObject, isValidString } from '../../../../../../catalog/Validity';
import { context } from '../../../../../../globalState/GlobalState';
import Button1 from '../../../../../uiElements/buttons/Button1';
import { EventType } from '../../../../../../catalog/enums/EventType';
import EventThumbnail1 from '../../../../../uiElements/eventAndPracticeThumbnails/eventThumbnail1/EventThumbnail1';
import PlaceholderComponent3 from '../../../../../uiElements/placeholderComponents/placeholderComponent3/PlaceholderComponent3';

const HomePage1Events1 = (props) => {
    const { events, upcoming } = props;
    const { globalState } = useContext(context);
    const history = useHistory();

    return (
        <div className="full-width">
            <div className="homepage1-events1-container x-center m-l-70px">
                {events.length > 0 ? (
                    <div className="large-events">
                        {events.map((event) => {
                            return (
                                <React.Fragment key={event.id}>
                                    {event.eventType === EventType.EVENT
                                        ? (<EventThumbnail1 id={event.id} articleId={event.articleId} title={event.title} venue={event.venue} timeOfEvent={event.timeOfEvent} endTimeOfEvent={isValidObject(event.endTimeOfEvent) ? event.endTimeOfEvent : event.timeOfEvent} />)
                                        : null}
                                </React.Fragment>
                            );
                        })}
                    </div>
                ) : (<PlaceholderComponent3 text={upcoming ? 'No Upcoming Events' : 'No Past Events'} />)}
            </div>
            <div className="homepage1-events1-container-more-container m-l-70px m-t-50px">
                <Button1
                    onClick={() => { history.push(upcoming ? '/events/upcoming' : '/events/past'); }}
                    title="More"
                    backgroundColor={globalState.websiteStyles.colors.primaryColor}
                    fontColor={isValidString(globalState.websiteStyles.colors.fontColor) ? `${globalState.websiteStyles.colors.fontColor}` : 'white'}
                    fontSize="1.6rem"
                    fontFamily="HelveticaNeue-CondensedBold, Roboto Condensed, Helvetica Neue, Helvetica,Arial, sans-serif"
                    borderRadius="10px"
                    width="180px"
                />
            </div>
        </div>
    );
};

HomePage1Events1.propTypes = {
    events: PropTypes.array.isRequired,
    upcoming: PropTypes.bool,
};

HomePage1Events1.defaultProps = {
    upcoming: true,
};

export default memo(HomePage1Events1);
